const homeRouter = [
    // 主页
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index.vue')
    }, // 企业码
    {
      path: '/home/code',
      name: 'code',
      component: () => import('@/views/home/code.vue')
    },
    // 生成企业码
    {
      path: '/home/generateCode',
      name: 'generateCode',
      component: () => import('@/views/home/generateCode.vue')
    },
    // 项目管家
    {
      path: '/home/manager',
      name: 'manager',
      component: () => import('@/views/home/manager.vue')
    },
    // 日志
    {
      path: '/home/log',
      name: 'log',
      component: () => import('@/views/home/log.vue')
    },
    // 日志编辑
    {
      path: '/home/editLog',
      name: 'editLog',
      component: () => import('@/views/home/editLog.vue')
    },
    // 日志详情
    {
      path: '/home/logDetail',
      name: 'logDetail',
      component: () => import('@/views/home/logDetail.vue')
    },
    // 电话本
    {
      path: '/home/phonebook',
      name: 'phonebook',
      component: () => import('@/views/home/phonebook.vue')
    },
    // 电话本详情
    {
      path: '/home/phoneDetail',
      name: 'phoneDetail',
      component: () => import('@/views/home/phoneDetail.vue')
    },
  ]
  export default homeRouter